import Vue from 'vue'
import Router from 'vue-router'
import {RouterPermissionMiddleware} from "@/middleware/RouterPermissionMiddleware";
import { routes } from './routes'
import { CognitoAuth } from '@/services/Auth/cognito';

Vue.use(Router)

const router = new Router({
    mode: "history",
    base: "",
    routes
})

// Gate de Cognito — corre ANTES del middleware de permisos existente
router.beforeEach(async (to, from, next) => {
  if (to.path === '/auth/callback') return next();          // deja procesar el retorno
  if (await CognitoAuth.isAuthenticated()) return next();   // ya autenticado en Cognito
  await CognitoAuth.login({ from: to.fullPath });           // si no, redirige a la Hosted UI
  // no llamamos next(): la página ya se está yendo a Cognito
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({...context, next: nextMiddleware});
    };
}


router.beforeEach((to, from, next) => {
    if (to.name) {
        document.title = to.name;
    }

    const globalMiddlewares = [RouterPermissionMiddleware];

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        if (Array.isArray(middleware)) {
            globalMiddlewares.forEach((_middleware) => {
                middleware.push(_middleware);
            })
        }

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();
});

router.onError(error => {
    console.error(error);
    Vue.prototype.$log.error('Failure Reason: ', error.message, error);
    if (/ChunkLoadError:.*failed./i.test(error.message)) {
      Vue.prototype.$log.error('Reloading Window 1');
      window.location.reload();
    }
    else if (/Loading.*chunk.*failed./i.test(error.message)) {
      Vue.prototype.$log.error('Reloading Window 2');
      window.location.reload();
    }
});

export default router;
